import InfoOutlined from '@mui/icons-material/InfoOutlined'
import { Stack, Tooltip, Typography } from '@mui/material'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useTraitColumns = ({
  traitIdHeaderName,
  years,
  renderYearCell,
}: {
  traitIdHeaderName: string
  years: string[]
  renderYearCell: (year: string) => (params: GridRenderCellParams) => ReactElement
}): GridColDef[] => {
  const { t } = useTranslation(['traits', '@cibo/programs/TaskEditorTable'])

  return useMemo(
    () => [
      {
        field: 'traitId',
        headerName: traitIdHeaderName,
        flex: 1.5,
        renderCell: ({ value }: GridRenderCellParams) => (
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="space-between"
            width="100%"
          >
            <Typography>{t(value, { ns: 'traits' })}</Typography>
            <Tooltip title={t(`${value}_description`, { ns: '@cibo/programs/TaskEditorTable' })}>
              <InfoOutlined color="action" />
            </Tooltip>
          </Stack>
        ),
      },
      ...years.map((year: string) => ({
        field: year,
        headerName: year,
        flex: 1,
        sortable: false,
        renderCell: renderYearCell(year),
      })),
    ],
    [traitIdHeaderName, years, renderYearCell, t]
  )
}
